import React from 'react';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import { SvgIcon, SvgIconProps } from '@mui/material';

const AiSparklesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    {/* Main large sparkle - outline only */}
    <path d="M12 2L15 10L22 12L15 14L12 22L9 14L2 12L9 10L12 2Z" fill="none" stroke="currentColor" strokeWidth="1.5" />
    {/* Small sparkle in top right */}
    <path d="M19 2L20 4.5L22 5L20 5.5L19 8L18 5.5L16 5L18 4.5L19 2Z" fill="currentColor" />
    {/* Small sparkle in bottom right */}
    <path d="M19 16L20 18.5L22 19L20 19.5L19 22L18 19.5L16 19L18 18.5L19 16Z" fill="currentColor" />
  </SvgIcon>
);

export type AutoFixHighDirection = 'north' | 'south' | 'down';

export interface AutoFixHighDirectionIconProps {
  direction: AutoFixHighDirection;
  /** Toolbar: default; menu: slightly smaller for `ListItemIcon`. */
  variant?: 'toolbar' | 'menu';
  /** `normal` — Initial categories preset in Structure categories (AI); default `high` for other AI category tools. */
  sparkle?: 'high' | 'normal';
}

const DIRECTION_ROTATE_DEG: Record<AutoFixHighDirection, number> = {
  north: 0,
  south: 90,
  down: 180,
};

/** north — Structure categories (AI); down + normal — Initial categories preset in dialog. */
export function AutoFixHighDirectionIcon({
  direction,
  variant = 'toolbar',
  sparkle = 'high',
}: AutoFixHighDirectionIconProps) {
  const isMenu = variant === 'menu';
  const fontSize = isMenu ? 20 : 22;
  const rotate = DIRECTION_ROTATE_DEG[direction];
  const Icon = sparkle === 'normal' ? AutoFixNormalIcon : AutoFixHighIcon;
  return (
    <Icon
      sx={{
        fontSize,
        display: 'block',
        verticalAlign: 'middle',
        ...(rotate !== 0 ? { transform: `rotate(${rotate}deg)` } : {}),
      }}
    />
  );
}

export default AiSparklesIcon;
